import { render, staticRenderFns } from "./SplitTrain.vue?vue&type=template&id=47d007a1&scoped=true&"
import script from "./SplitTrain.vue?vue&type=script&lang=ts&"
export * from "./SplitTrain.vue?vue&type=script&lang=ts&"
import style0 from "./SplitTrain.vue?vue&type=style&index=0&id=47d007a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d007a1",
  null
  
)

export default component.exports